import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiMDelegatedService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  login(salt, returnUrl, sig) {
    return this.http.post(this.baseUrl + 'api-m/delegated-login', { salt, returnUrl, sig });
  }

  logout(salt, returnUrl, sig) {
    return this.http.post(this.baseUrl + 'api-m/delegated-login', { salt, returnUrl, sig });
  }
}
